import { render, staticRenderFns } from "./Dialogs_TeamAddStudent.vue?vue&type=template&id=03ca1589&scoped=true&"
import script from "./Dialogs_TeamAddStudent.vue?vue&type=script&lang=js&"
export * from "./Dialogs_TeamAddStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca1589",
  null
  
)

export default component.exports